<template>
    <b-card class="shadow-sm company-onboardings" header-bg-variant="" header-text-variant="black">
        <template v-slot:header>
            <div class="d-flex justify-content-between align-items-center" style="min-height: 28px;">
                <div class="d-flex align-items-baseline gap-4 flex-wrap">
                    <h5 class="mb-0">{{ title }}</h5>
                </div>
            </div>
        </template>
        <div class="">
            <div v-if="showSummaryNode" v-html="summaryNodeHtml" class=""></div>
            <b-table :items="onboardingList" :fields="fields" class="no-top-border">
                <template #cell(title)="slotProps">
                    <a :href="slotProps.item.permalink_url" class="font-weight-500">{{ slotProps.value }}</a>
                </template>
                <template #cell(sm_state)="slotProps">
                    <b-badge :variant="slotProps.item.current_sm_state_serialized.color_variant">
                        {{ slotProps.item.current_sm_state_serialized.badge_title }}
                    </b-badge>
                </template>
                <template #cell(created_by)="slotProps">
                    <tenant-user-badge :tu-data="slotProps.value" class="d-inline-flex"></tenant-user-badge>
                </template>
            </b-table>
            <!-- <pre>{{ onboardingList }}</pre> -->
        </div>
    </b-card>
</template>

<script>
import { suppliosApi } from '../../../js/api-service';
import { errorHandling, currentUserInfoMixin } from "../../../js/custom-vue-mixins";
import { FormatDateTimeLocal } from '../../../js/filters-helpers';

export default {
    name: 'VendorOnboardingList',
    props: {
        resource: {  // the full vendor object
            type: Object,
            required: true,
        },
    },
    mixins: [errorHandling, currentUserInfoMixin],
    i18n: {
        messages: {
            en: {
                vendorOnboardingList: {
                    title: 'Onboarding',
                    fields: {
                        title: 'Onboarding Workflow',
                        status: 'Status',
                        startedBy: 'Started By',
                        startedOn: 'Started On',
                    },
                },
            },
            es: {
                vendorOnboardingList: {
                    title: 'Onboarding',
                    fields: {
                        title: 'Flujo de Onboarding',
                        status: 'Estado',
                        startedBy: 'Iniciado por',
                        startedOn: 'Fecha de Inicio',
                    },
                },
            },
            pt: {
                vendorOnboardingList: {
                    title: 'Onboarding',
                    fields: {
                        title: 'Fluxo de Onboarding',
                        status: 'Status',
                        startedBy: 'Iniciado por',
                        startedOn: 'Data de Início',
                    },
                },
            },
            'zh-Hans': {
                vendorOnboardingList: {
                    title: '供应商准入',
                    fields: {
                        title: '准入流程',
                        status: '状态',
                        startedBy: '发起人',
                        startedOn: '发起时间',
                    },
                },
            },
            'zh-Hant': {
                vendorOnboardingList: {
                    title: '供應商導入',
                    fields: {
                        title: '導入流程',
                        status: '狀態',
                        startedBy: '發起人',
                        startedOn: '發起時間',
                    },
                },
            },
        },
    },
    data() {
        return {
            loading: false,
            onboardingList: [],
            showSummaryNode: false,
            summaryNodeHtml: '',  
            summaryNodeKey: 'display_summary',
        }
    },
    computed: {
        title() {
            return this.$t('vendorOnboardingList.title');
        },
        fields() {
            return [
                {
                    key: 'title',
                    label: this.$t('vendorOnboardingList.fields.title'),
                },
                {
                    key: 'sm_state',
                    label: this.$t('vendorOnboardingList.fields.status'),
                    class: 'text-center',
                },
                {
                    key: 'created_by',
                    label: this.$t('vendorOnboardingList.fields.startedBy'),
                    class: 'text-center'
                    // pass the whole object through... show TU badge?
                },
                {
                    key: 'created',
                    label: this.$t('vendorOnboardingList.fields.startedOn'),
                    formatter: (val) => {
                        return FormatDateTimeLocal(val);
                    },
                },
            ];
        },
    },
    mounted() {
        this.getOnboardings();
    },
    methods: {
        async getOnboardings() {
            // SKIP API CALL IF NO FLAG FOR ONBOARDING ENABLED?
            this.loading = true;
            let resp;
            try {
                resp = await suppliosApi.onboarding.list_for_vendor_internal(this.resource.id);
            } catch (error) {
                // maybe swallow errors here in case some tenants don't have this implemented???  no, we should block from calling this instead...
                this.apiErrorHandler(error);
            }
            if (resp?.data) {
                this.onboardingList = resp.data;
                const firstOnboardingId = Array.isArray(resp.data) && resp.data.length ? resp.data[0].id : '';
                if (firstOnboardingId && this.showSummaryNode) {
                    this.getSummaryNode(firstOnboardingId);
                }

            }
            this.loading = false;
        },
        async getSummaryNode(onboardingId) {
            // SKIP API CALL IF NO FLAG FOR ONBOARDING ENABLED?
            this.loading = true;
            let resp;
            try {
                resp = await suppliosApi.onboarding.get_node_detail(onboardingId, this.summaryNodeKey);
            } catch (error) {
                this.apiErrorHandler(error);
            }
            if (resp?.data) {
                this.summaryNodeHtml = resp.data.content;
            }
            this.loading = false;
        },
    },
};
</script>
